import React, { Component } from 'react';
import PSPDFKit from '../pspdfkit';
import { getOrder, getReviewForms } from '../../api/choiceforms';
/**
 * need button to save changes/move to the next step
 *   pass in functino so we can call when done
 *
 * url client/order
 * call out to client/fillableforms/order to get list of forms we need to fill out
 * get the first form and display
 * on submit capture data as formid/whatever
 * go to next
 * when done submit to client/fillableform/*orderid
 * redirect to the page that is returned
 */

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

export class FormReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedForms: {}
    };
  }

  async componentDidMount() {
    // incmoing params are client, and path
    //path will return [{pdfurl, xfdf}]
    const client = this.props.match.params.client;
    const formPath = this.props.match.params.formpath;
    try {
      const forms = await getReviewForms(client, formPath);
      console.log(forms);
      let currentForm = 0;
      const pdfURL = forms[currentForm].pdfURL;
      const xfdf = forms[currentForm].xfdf;
      console.log(pdfURL);
      console.log('done');

      this.setState((state, props) => {
        return {
          client,
          currentForm,
          forms,
          finishedLoading: true,
          pdfURL,
          xfdf
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  async formCompleted(formid, xfdf) {
    // add formd data
  }

  render() {
    let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
    var host = `https://${this.state.client}`;
    if (process.env.NODE_ENV === 'development') {
      host = `http://${this.state.client}`;
    }
    if (this.state.finishedLoading) {
      const form = this.state.forms[this.state.currentForm];
      console.log('Current Form: ' + this.state.currentForm);
      console.log(form);
      const formUrl = `${host}${form.pdfURL}`;
      const title = `Form ${this.state.currentForm + 1} of ${
        this.state.forms.length
      }`;
      return (
        <div
          className="App"
          style={{
            backgroundColor: '#fff',
            maxWidth: '1170px',
            marginRight: 'auto',
            marginLeft: 'auto'
          }}
        >
          <img alt="form hero" src={host + '/casfiles/fillableform_hero.png'} />
          {this.state.error && <div>{this.state.errorMessage}</div>}
          {this.state.finishedLoading && (
            <PSPDFKit
              documentId={this.state.currentForm}
              pdfUrl={formUrl}
              licenseKey={licenseKey}
              baseUrl={baseUrl}
              completedForm={xfdf => {
                this.formCompleted('', xfdf);
              }}
              hideToolbar={true}
              title={title}
              maxWidth="1170px"
              xfdf={this.state.xfdf}
            />
          )}
        </div>
      );
    }
    return null;
  }
}

export default FormReview;
